var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { ERRORS } from '../../Fct/errors';
import { FctParam, } from './FctParams';
var Input = /** @class */ (function () {
    function Input(_fctParams, chainId) {
        var _this = this;
        this._warnings = new Map();
        this._errors = new Map();
        this.subscribe = function (_a) {
            var callback = _a.callback, id = _a.id;
            _this.observers.set(id, callback);
        };
        this.unsubscribe = function (_a) {
            var id = _a.id;
            _this.observers.delete(id);
        };
        this.updateSubscriptions = function (paramKey) {
            var e_1, _a;
            try {
                for (var _b = __values(_this.observers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var observer = _c.value;
                    observer[1](_this.params, _this._errors, _this.chainId, paramKey);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
        this.observers = new Map();
        this.get = function () { return _this.params; };
        this.validate = function (params, errors) { return true; };
        this._params = _fctParams.input;
        this._methodParams = _fctParams.input.methodParams;
        this.paramsList.forEach(function (element) {
            element.param.subscribe({ callback: function () { return _this.updateSubscriptions(element.key); }, id: element.key });
        });
        this.chainId = chainId;
    }
    Object.defineProperty(Input.prototype, "params", {
        get: function () {
            return this._params;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "paramsList", {
        get: function () {
            var list = [];
            var setParamsList = function (inputParams, prevKey) {
                for (var key in inputParams) {
                    var name_1 = key;
                    var fctParam = inputParams[key];
                    var uniqueKey = (prevKey ? "".concat(prevKey, ".").concat(name_1) : name_1);
                    if (fctParam instanceof FctParam) {
                        list.push({ param: fctParam, key: uniqueKey });
                    }
                    else {
                        setParamsList(inputParams[key], uniqueKey ? uniqueKey : undefined);
                    }
                }
            };
            setParamsList(this.params);
            return list;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "methodParams", {
        get: function () {
            return this._methodParams;
        },
        enumerable: false,
        configurable: true
    });
    Input.prototype.set = function (params) {
        var setParams = function (params, inputParams) {
            for (var key in params) {
                var fctParam = inputParams[key];
                if (!fctParam)
                    continue;
                if (fctParam instanceof FctParam) {
                    fctParam === null || fctParam === void 0 ? void 0 : fctParam.set({ value: params[key] });
                }
                else {
                    setParams(params[key], inputParams[key]);
                }
            }
        };
        setParams(params, this.params);
        return this.isValid;
    };
    Input.prototype.setMethodParams = function (params) {
        var setParams = function (pluginParams, paramsToSet) {
            Object.keys(pluginParams).forEach(function (paramKey, i) {
                if (!(pluginParams[paramKey] instanceof FctParam)) {
                    return setParams(pluginParams[paramKey], params[0]);
                }
                if (pluginParams[paramKey].fctType === 'tuple[]') {
                    var paramValue = paramsToSet[i];
                    if (!paramValue)
                        return;
                    if (typeof paramValue !== 'object' || !('length' in paramValue))
                        return;
                    var tupleParam = pluginParams[paramKey];
                    if (tupleParam.setString && typeof tupleParam.setString === 'function')
                        tupleParam.setString({ value: paramValue.join(',') });
                    return;
                }
                if (typeof paramsToSet[i] === 'boolean') {
                    pluginParams[paramKey].value = String(paramsToSet[i]);
                    return;
                }
                pluginParams[paramKey].value = paramsToSet[i];
            });
        };
        setParams(this.params.methodParams, params);
    };
    Object.defineProperty(Input.prototype, "warnings", {
        get: function () {
            var e_2, _a;
            this._warnings.clear();
            try {
                for (var _b = __values(this.paramsList), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = _c.value, param = _d.param, key = _d.key;
                    var risk = param.risk;
                    var isDanger = risk === null || risk === void 0 ? void 0 : risk.isDanger(param.value);
                    if (risk && isDanger) {
                        this._warnings.set(key, risk.description);
                        continue;
                    }
                    this._warnings.delete(key);
                    continue;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            if (this._warnings.size > 0)
                return this._warnings;
            return;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "errors", {
        get: function () {
            var e_3, _a;
            this._errors.clear();
            try {
                for (var _b = __values(this.paramsList), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = _c.value, param = _d.param, key = _d.key;
                    if (param.value === undefined && param.required && (key.includes('methodParams') || key === 'to')) {
                        this._errors.set(key, ERRORS.PARAM_NOT_DEFINED);
                        continue;
                    }
                    var isValidParam = param.isValid();
                    if (isValidParam.state) {
                        this._errors.delete(key);
                        continue;
                    }
                    this._errors.set(key, isValidParam.error || ERRORS.INVALID_VALUE);
                    continue;
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            if (this._errors.size > 0)
                return this._errors;
            return;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "isValid", {
        get: function () {
            if (!this.errors)
                return true;
            if (this.errors.size > 0)
                return false;
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return Input;
}());
export { Input };
